// self-care data adapter for the Jarabot product context bundle (ADR-0005).
// Reuses the app's existing query documents, so our watchQuery shares the Apollo
// cache and the app's post-action refetch/evict flows drive our targeted updates.

import { outagesSource, transactionsSource } from './sources/activity';
import {
	deferredPaymentsSource,
	installmentsSource,
	payInThreeSource,
} from './sources/applications';
import { billingSource, contractSource } from './sources/contract';
import { complianceSource, eligibilitySource } from './sources/profile';
import { cardSource, cashbackSource, coinsSource } from './sources/rewardsAndCard';
import { ContextAdapter } from './types';

export const selfCareContextAdapter: ContextAdapter = [
	eligibilitySource,
	complianceSource,
	contractSource,
	billingSource,
	payInThreeSource,
	deferredPaymentsSource,
	installmentsSource,
	coinsSource,
	cashbackSource,
	cardSource,
	transactionsSource,
	outagesSource,
	// offers (AC13) deferred: banners come from redux/REST (useBanner), not watchQuery.
];
